module.exports = __webpack_public_path__ + "static/media/ill-2.594b1ee1.svg";